import React from 'react';
import DefaultButton from '../../../atoms/Buttons/DefaultButton';
import { ButtonProps } from '@mui/material';

type ActionButtonProps = {
  label: string;
} & ButtonProps;

export default function ActionButton({
  label,
  ...buttonProps
}: ActionButtonProps) {
  return <DefaultButton {...buttonProps}>{label}</DefaultButton>;
}
